import { Switch, withStyles } from "@material-ui/core";

const PlanSwitch = withStyles((theme) => ({
	root: {
		width: 52,
		height: 26,
		padding: 0,
		margin: theme.spacing(1.5),
	},
	switchBase: {
		padding: 1,
		margin: 1,
		"&$checked": {
			transform: "translateX(26px)",
			color: theme.palette.common.white,
			"& + $track": {
				backgroundColor: theme.palette.primary.main,
				opacity: 1,
				border: "none",
				color: theme.palette.primary.main,
			},
		},
		"&$focusVisible $thumb": {
			color: "#52d869",
			border: "6px solid #fff",
		},
	},
	thumb: {
		margin: 1,
		width: 20,
		height: 20,
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.primary.main,
		opacity: 1,
		transition: theme.transitions.create(["background-color", "border"]),
	},
	checked: {},
	focusVisible: {},
}))(({ classes, ...props }) => {
	return (
		<Switch
			classes={{
				root: classes.root,
				switchBase: classes.switchBase,
				thumb: classes.thumb,
				track: classes.track,
				checked: classes.checked,
			}}
			{...props}
		/>
	);
});

export default PlanSwitch;
